export default {
  SERVER_ENDPOINT: process.env.REACT_APP_SERVER_ENDPOINT,
  WS_SERVER_ENDPOINT: process.env.REACT_APP_WS_SERVER_ENDPOINT,
  STRIPE_KEY: process.env.REACT_APP_STRIPE_KEY,
  ReCAPTCHA_KEY: process.env.REACT_APP_ReCAPTCHA_KEY,
  PUBLIC_URL: process.env.PUBLIC_URL,
  URL: process.env.REACT_APP_URL,
  DOMAIN: process.env.REACT_APP_DOMAIN,
  IS_DEMO: process.env.REACT_APP_IS_DEMO,
  IS_PROD: process.env.REACT_APP_IS_PROD,
  MAPBOX_TOKEN: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN,
  SENTRY_ENV: process.env.REACT_APP_SENTRY_ENV,
  SENTRY_DSN_URL: process.env.REACT_APP_SENTRY_DSN_URL,
  API_KEY: process.env.REACT_APP_API_KEY,
  MIXPANEL_TOKEN: process.env.REACT_APP_MIXPANEL_TOKEN,
  ONLYOFFICE_URL: process.env.REACT_APP_ONLYOFFICE_URL,
};
